// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"22":"end-user","145":"permission-mgt","204":"direct","216":"container","641":"user-mgt","748":"multinational","855":"e-learning"}[chunkId] + "." + {"22":"e03dea35","145":"7c9d2c08","204":"480a47e0","216":"07b20909","641":"3554a72c","748":"e51ddd0c","855":"3095f696"}[chunkId] + ".js";
};